import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Services = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleSectionClick = (sectionId) => {
    // If we're already on the home page, just scroll to section
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // If we're on another page, navigate to home first, then scroll to section
      navigate('/');
      // Wait for navigation to complete, then scroll to section
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  };

  const services = [
    {
      icon: 'fas fa-user-md',
      title: 'Oral Cancer Surgery',
      description: 'Advanced surgical care for oral and head & neck cancers with precision techniques and comprehensive treatment plans.',
      color: 'primary',
      gradient: 'from-primary-500 to-primary-600'
    },
    {
      icon: 'fas fa-female',
      title: 'Gynecological Cancer Surgery',
      description: 'Expertise in ovarian, uterine, and cervical cancer surgeries with minimally invasive approaches.',
      color: 'accent',
      gradient: 'from-accent-500 to-accent-600'
    },
    {
      icon: 'fas fa-stethoscope',
      title: 'Thyroid & Endocrine Surgery',
      description: 'Comprehensive thyroid and endocrine tumor management with state-of-the-art surgical techniques.',
      color: 'medical',
      gradient: 'from-medical-500 to-medical-600'
    },
    {
      icon: 'fas fa-heartbeat',
      title: 'Gastrointestinal Cancer Surgery',
      description: 'Specialized care for GI tract cancers including stomach, colon, and rectum with advanced procedures.',
      color: 'gold',
      gradient: 'from-gold-500 to-gold-600'
    }
  ];

  return (
    <section id="services" className="section bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="section-title">Our Specialized Services</h2>
          <p className="section-subtitle">
            Comprehensive cancer care with advanced surgical techniques and personalized treatment plans
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="card p-8 text-center group animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${service.gradient} rounded-2xl flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="font-heading text-xl font-bold text-primary-700 mb-4 group-hover:text-primary-600 transition-colors duration-300">
                {service.title}
              </h3>
              
              <p className="text-text-secondary leading-relaxed">
                {service.description}
              </p>

              <div className="mt-6 pt-6 border-t border-neutral-100">
                <div className="flex items-center justify-center gap-2 text-sm text-text-secondary">
                  <i className="fas fa-check-circle text-medical-500"></i>
                  <span>Expert Care</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Services CTA */}
        <div className="mt-16 text-center">
          <div className="card-glass p-8 max-w-2xl mx-auto">
            <h3 className="font-heading text-2xl font-bold text-primary-700 mb-4">
              Comprehensive Cancer Care
            </h3>
            <p className="text-text-secondary mb-6 leading-relaxed">
              Beyond these specialties, we offer a full spectrum of cancer treatment services including 
              consultation, diagnosis, treatment planning, and follow-up care.
            </p>
            <button 
              onClick={() => handleSectionClick('contact')} 
              className="btn-medical inline-flex items-center gap-3"
            >
              <i className="fas fa-calendar-alt"></i>
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services; 